window.SwiperManager = {
  init() {
    if (!window.Swiper) {
      console.warn("Swiper library not loaded");
      return;
    }

    this.initColorsSwiper();
    this.initLookbookSwiper();
    this.initImageBannerSwiper();
  },

  initColorsSwiper() {
    const colorsSwiper = document.querySelector(".colors-swiper");
    if (!colorsSwiper) return;

    new Swiper(".colors-swiper", {
      direction: "horizontal",
      slidesPerView: 2.6,
      loop: true,

      navigation: {
        nextEl: ".colors-swiper-next",
        prevEl: ".colors-swiper-prev",
      },

      breakpoints: {
        400: {
          slidesPerView: 3.4,
        },
        768: {
          slidesPerView: 5,
        },
        1280: {
          slidesPerView: 10,
        },
      },
    });
  },

  initLookbookSwiper() {
    const lookbookSwiper = document.querySelector(".lookbook-swiper");
    if (!lookbookSwiper) return;

    new Swiper(".lookbook-swiper", {
      direction: "horizontal",
      slidesPerView: 1.5,
      spaceBetween: 27,
      loop: true,

      navigation: {
        nextEl: ".lookbook-swiper-next",
        prevEl: ".lookbook-swiper-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1280: {
          slidesPerView: 3,
        },
      },
    });

    this.bindLookbookEvents();
  },

  bindLookbookEvents() {
    document.addEventListener("click", (e) => {
      const allSlides = document.querySelectorAll(".swiper-slide");
      const allHotspots = document.querySelectorAll(".hotspot");
      const clickedSlide = e.target.closest(".swiper-slide");
      const clickedHotspot = e.target.closest(".hotspot");

      allSlides.forEach((slide) => slide.classList.remove("active"));
      allHotspots.forEach((hotspot) => hotspot.classList.remove("active"));

      if (clickedSlide) {
        clickedSlide.classList.add("active");
      }

      if (clickedHotspot) {
        clickedHotspot.classList.toggle("active");
      }
    });
  },

  initImageBannerSwiper() {
    const bannerSwiper = document.querySelector(".banner-swiper");
    if (!bannerSwiper) return;

    const hasPagination = document.querySelector(".swiper-pagination");
    const hasNavigation = document.querySelector(".banner-swiper-button--next");

    const slideCount = bannerSwiper.querySelectorAll(".swiper-slide").length;

    const swiperConfig = {
      direction: "horizontal",
      slidesPerView: 1,
      loop: slideCount > 1,

      autoplay:
        slideCount > 1
          ? {
              delay: 5000,
              disableOnInteraction: false,
            }
          : false,

      scrollbar: {
        el: ".swiper-scrollbar",
      },
    };

    if (hasPagination) {
      swiperConfig.pagination = {
        el: ".swiper-pagination",
      };
    }

    if (hasNavigation) {
      swiperConfig.navigation = {
        nextEl: ".banner-swiper-button--next",
        prevEl: ".banner-swiper-button--prev",
      };
    }

    const swiper = new Swiper(".banner-swiper", swiperConfig);

    this.setupResponsiveImages();
  },

  setupResponsiveImages() {
    const updateResponsiveImages = () => {
      const slides = document.querySelectorAll(".banner-swiper-slide");
      const isMobile = window.innerWidth <= 768;

      slides.forEach((slide) => {
        const mobileImage = slide.getAttribute("data-mobile-image");

        if (!slide.getAttribute("data-desktop-image")) {
          const currentBg = slide.style.backgroundImage;
          const urlMatch = currentBg.match(/url\(['"]?([^'"]*?)['"]?\)/);
          if (urlMatch) {
            slide.setAttribute("data-desktop-image", urlMatch[1]);
          }
        }

        const desktopImage = slide.getAttribute("data-desktop-image");

        if (isMobile && mobileImage) {
          slide.style.backgroundImage = slide.style.backgroundImage.replace(
            /url\(['"]?[^'"]*['"]?\)/,
            `url('${mobileImage}')`
          );
        } else if (!isMobile && desktopImage) {
          slide.style.backgroundImage = slide.style.backgroundImage.replace(
            /url\(['"]?[^'"]*['"]?\)/,
            `url('${desktopImage}')`
          );
        }
      });
    };

    updateResponsiveImages();
    window.addEventListener("resize", updateResponsiveImages);
  },
};

document.addEventListener("DOMContentLoaded", () => {
  window.SwiperManager.init();
});

document.addEventListener("shopify:section:load", () => {
  window.SwiperManager.init();
});
